/*
 * @Author: LCQ
 * @Date: 2024-08-07 10:03:28
 * @LastEditTime: 2024-08-13 17:42:15
 * @LastEditors: LCQ
 * @Description: 收车任务单
 * @FilePath: \operation.dstcar.com\src\router\collectionCarTask\index.js
 */

export default [
  {
    path: '/collectionCarTask/list',
    name: 'CollectionCarTaskList',
    component: () => import('@/pages/collectionCarTask/list'),
    meta: {
      storeKey: 'oss:recycle:task'
    }
  },
  {
    path: '/collectionCarTask/detail',
    name: 'CollectionCarTaskDetail',
    component: () => import('@/pages/collectionCarTask/detail'),
    meta: {
      storeKey: '*'
    }
  },
  {
    path: '/collectionCarTask/assign',
    name: 'CollectionCarTaskAssign',
    component: () => import('@/pages/collectionCarTask/assign'),
    meta: {
      storeKey: '*'
    }
  },
  {
    path: '/collectionCarTask/reAssign',
    name: 'CollectionCarTaskReAssign',
    component: () => import('@/pages/collectionCarTask/reAssign'),
    meta: {
      storeKey: '*'
    }
  },
  {
    path: '/collectionCarTask/cancel',
    name: 'CollectionCarTaskCancel',
    component: () => import('@/pages/collectionCarTask/cancel'),
    meta: {
      storeKey: '*'
    }
  },
  {
    path: '/collectionCarTask/editReason',
    name: 'CollectionCarTaskEditReason',
    component: () => import('@/pages/collectionCarTask/editReason'),
    meta: {
      storeKey: '*'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/collectionCarTask/index.js